export default {
  path: 'aigc_company',
  component: () => import(/* webpackChunkName: "aigc-company" */ '@/pages/aigcCompany'),
  meta: {
    title: 'AIGC商户'
  }
}
